import 'jquery-ui/themes/base/base.css';

import $                    from 'jquery';
import draggable            from 'jquery-ui/ui/widgets/draggable.js';
import droppable            from 'jquery-ui/ui/widgets/droppable.js';
import {View,Model}         from 'backbone';
import _template            from 'dashboard/dashboard-left-panel.ejs';
import groupItemTemplate    from 'dashboard/group-items.ejs';
import sectionItemsTemplate from 'dashboard/section-items.ejs';
import singleItemTemplate   from 'dashboard/single-item.ejs';
import eventBus             from 'EventBus.js';
import util                 from 'util/Util.js';
import constants            from 'Constants';
import restService          from 'RestService';
import BootstrapMenu        from 'bootstrap-menu';
import NotificationService  from 'NotificationService.js';
import formFolderService    from 'FormFolderService.js';
import reportFolderService    from 'ReportFolderService.js';
import SimpleConfirmModalView from 'common-views/SimpleConfirmModalView.js';
import trialStatus            from 'dashboard/app-trial-status.ejs';
import listService from 'ListService';

class BaseDashboardLeftPanelView extends View {

    initialize(opts) {
        this.options = opts || {};
        this.template = _template;
        this.detailView = undefined;
        this.contextMenus;
        this.restrictedItems = ['users', 'userGroup', 'positions', 'synchronize', 'listGroup', 'emailGroup', 'viewableFormInstance', 'libraryForms', 'attentionNeeded', 'noAttentionNeeded', ''];

        this.events = {
            //'click .document-heading': 'handleSection',
            'click .document-heading' : 'handleExpand',
            'click ul.group-items li i' : 'handleExpand',
            'click .bo-heading': 'handleSelectedGroup',
            'click ul.group-items li a.item-link' : 'handleSelectedGroupItem',
            'dblclick a.item-link' : 'handleDblSelectedGroupItem',
            'focusout a.item-link > input' : 'handleFocusOut',
            'keyup a.item-link > input' : 'handleEnter',
            'click #import':'import',
            'click #createNew':'createNew',
            'click #createFolder':'createFolder',
            'click #createAccountFolder':'createFolder',
            'click #createPersonalFolder':'createFolder',
            'click #email-server':'createNewEmailServer',
            'click #user':'createNewUser',
            'click #user-group':'createNewUserGroup',
            'click #position':'createNewUserPosition',
            'click #list':'createNewList',
            'click #database':'createNewDatabase',
            'click #directory-service':'createNewDirectoryService',
            'click #web-service':'createNewWebService',
            'click #rest-web-service':'createNewRestWebService',
            'click #form-connection':'createNewForm',
            'click #google-spreadsheet':'createNewGoogleSpreadsheet',
            'click #text-file':'createNewTextFile',
            'click #vectordb':'createNewVectorDB',
            'keydown #formReportSearch':'validateEnter',
            'click #getQuote': 'requestQuote'
        };

        this.sections = {
            PRIVATE_FORMS: 'PrivateForms',
            VIEW_FORMS: 'ViewForms',
            SHARED_FORMS: 'SharedForms',
            LIBRARY: 'Library',
            SETTINGS: 'Settings',
            USERS: 'Users',
            RESOURCES: 'Resources'
        };

        this.listenTo(eventBus, constants.EV_LOAD_TRIAL_STATUS, (reload) => { this.loadTrialStatus(reload) });

        return this;
    }

    //======================================================================================================================
    // Method that stops the propagation of events on the Left Panel Views so no more than one API is called on expansion
    //======================================================================================================================
    collapseWithoutPropagation(ev) {
        ev.stopPropagation();

        let dataTarget;
        if (ev.currentTarget.attributes['data-target']) {
            dataTarget = ev.currentTarget.attributes['data-target'].value;
        }

        if (dataTarget) {
            let domTarget = $('a[data-target="'+ dataTarget + '"] i'); 
            let eventTarget = $(ev.target);
            let currentTarget = $(ev.currentTarget)

            if (!domTarget.length) {
                if (eventTarget.is('a')) {
                    domTarget = eventTarget.siblings('i');
                }
                else {
                    domTarget = $('i[data-target="'+ dataTarget + '"]');
                }
            }
         
            $(dataTarget).collapse("toggle"); 
            util.togglePanel(currentTarget, domTarget);           
        }        
    }

    killDetailView(remove = false, empty = false) {
        let _detailView = this.detailView || listService.dashboardLayout.mainPanelView; //TODO: Remove the DetailsView duplicate
        if (_detailView) {
            _detailView.undelegateEvents();
            _detailView.stopListening();
            remove && _detailView.remove();
            empty && _detailView.$el.html('');
        }
    }

    handleExpand(ev) {}

    renderReportDetails() {}
    renderConnectionDetails() {}
    renderActionDetails() {}

    handleSection(ev) {
        let target = $(ev.target);
        let activeEl;
        let currentTarget = ev.currentTarget;

        let currentDOMElement = $(ev.currentTarget); 
        
        activeEl = currentDOMElement.parents('.document');
        if (activeEl.hasClass('dashboard') && !target.parent().is("a")) {   
            $('.document').removeClass('active');
            $(activeEl).addClass('active');
        }        
    }

    activateSection(ev, id = null) {
        let target;
        if (id) {
            target = $(id);
        }
        else {
            target = $(ev.target);
        }       

        let parent = target.closest('.document.dashboard');
        if (parent && parent.length) {
            $('.document').removeClass('active');
            parent.addClass('active');
        }
    }

    handleSelectedGroup(ev) {}

    // Override this to handle specific actions in derived classes.
    handleSelectedGroupItem(ev) {
        // Base method will use BB Routes via the URL attribute of the selected item.
    }
    // handleDblSelectedGroupItem(ev) {}
    // handleFocusOut(ev){}
    // handleEnter(ev){}

    addItemsToGroup(group, target) {
        console.log('add items to ' + target);
        // add to <UL>
        $(target + ' UL').html(groupItemTemplate(group));

        this.makeDraggables();
        this.makeDroppables();
        this.attachRightClickMenu();
    }

    makeDraggables() {
        util.jqCls('draggableItem').each((i, o)=>{
            $(o).draggable(this._optionsForDraggable( o ));
        });
    }

    makeDroppables() {
        const that = this;
        $('.droppableContainer').droppable({
            classes: {
                "ui-droppable-active": "pf-ui-state-active",
                "ui-droppable-hover": "pf-ui-state-hover"
            },
            over: function(event, ui){
                const $target = $(ui.draggable);
                const $destiny = $(event.target);
                const groups = {1:'private', 2:'shared'};

                if ($target.find('i').data('parentid') === $destiny.find('i').data('itemid')) {
                    $(ui.helper).removeClass('drop-disabled');
                } else {
                    $(ui.helper).addClass('drop-disabled');
                }
            },
            out: function(event, ui){
                $(ui.helper).removeClass('drop-disabled');
            },
            drop: (event, ui)=>{
                const tb = $(event.target),
                    $isUl = tb.siblings().find('ul'),
                    $itemDragged = $(ui.draggable),
                    $destinyFolder = $(event.target),
                    $item = $itemDragged.find('i'),
                    $itemForm = $itemDragged.find('a'),
                    $folder = $destinyFolder.find('i'),
                    $folderForm = $destinyFolder.find('a'),
                    itemData = $item.data('itemid').split('_'),
                    groupId = $folder.data('itemid') || constants.DEFAULT_GROUP_ID;

                if ($item.data('parentid') === groupId || ($item.data('parentid') === "" && groupId === constants.DEFAULT_GROUP_ID) ) {
                    return; 
                }

                const groupType = $folderForm.data('grouptype') || $destinyFolder.data('groupid'),
                    formId = itemData[1];
                
                const params = {
                    isPrivate: (groupType === Number(constants.FORMS_PRIVATE_GROUP_TYPE)),
                    groupId: groupId,
                    name: constants.DEFAULT_GROUP_ID,
                    groupType: groupType
                };

                if (this.model.get('currentActiveSection') === 'reportSections') {
                    const params = {
                        isPrivate: (groupType === Number(constants.REPORTS_PRIVATE_GROUP_TYPE)),
                        reportId: formId,
                        groupId: groupId,
                        name: constants.DEFAULT_GROUP_ID,
                        groupType: groupType,
                        itemId: `${groupType}_${formId}`
                    };
                    restService.shareReport(params).then((data) => {
                        ui.draggable.remove();
                        if ( params.groupId === constants.DEFAULT_GROUP_ID ) {
                            params.groupId = Number(params.groupType)-1;
                        }
                        const $selectedWell = $(`#well${params.groupId}`).length > 0 ? $(`#well${params.groupId}`) : $(`#well_${params.groupId}`);
                        if ( $selectedWell.attr('aria-expanded') === 'true' ) {
                            const templateParams = {
                                id: `${groupType}_${formId}`,
                                groupType: groupType,
                                icon: constants.DB_ICON_EMPTY,
                                nodeType: 'attn',
                                nodeName: data.Name,
                                parentId: data.GroupId,
                                toggleIcon: '',
                                selected: false
                            };

                           
                            if( $(`#well${params.groupId}`).length > 0 ){
                                if( $(`#well${params.groupId} > ul > li`).html() && $(`#well${params.groupId} > ul > li`).html().includes('no item') ){
                                    $(`#well${params.groupId} > ul > li`).remove(); 
                                }
                                $(`#well${params.groupId} > ul`).append(singleItemTemplate({node:templateParams}));
                            }else{
                                $(`#well_${params.groupId} > ul`).append(singleItemTemplate({node:templateParams}));
                            }
                    
                        } else {

                            if($(`i[data-target="#well${params.groupId}"]`).length > 0){
                                $(`i[data-target="#well${params.groupId}"]`).trigger('click');
                            }else{
                                $(`i[data-target="#well_${params.groupId}"]`).trigger('click');
                            } 

                        }
                        setTimeout(()=>{ this.makeDraggables(); }, 50);
                    }).catch((error) => {
                        NotificationService.error(error || 'Unknown Error');
                    });
                } else { // defaults to form
                    params['formId'] = formId;
                    restService.shareForm(params).then( data => {
                        
                        if ( params.groupId === constants.DEFAULT_GROUP_ID ) {
                            params.groupId = Number(params.groupType)+1;
                        }

                        const $selectedWell = $(`#well${params.groupId}`).length > 0 ? $(`#well${params.groupId}`) :  $(`#well_${params.groupId}`) ;
                        if ( $selectedWell.attr('aria-expanded') === 'true' ) {
                            const templateParams = {
                                groupType: params.groupType,
                                icon: '',
                                id: `${groupType}_${formId}`,
                                nodeName: data.Name,
                                nodeType: 'attn',
                                parentId: data.GroupId,
                                selected: false,
                                toggleIcon: ''
                            };
                            
                            const instancesData = that.lookForInstances($itemDragged);
                            if (instancesData && instancesData.instances.length > 0) {
                                templateParams.toggleIcon = 'pf-carot-left';
                            }
                            if($(`#well${params.groupId}`).length > 0){
                                if( $(`#well${params.groupId} > ul > li`).html() && $(`#well${params.groupId} > ul > li`).html().includes('no item') ){
                                    $(`#well${params.groupId} > ul > li`).remove(); 
                                }
                                $(`#well${params.groupId} > ul`).append(singleItemTemplate({node:templateParams}));
                                $(`#well${params.groupId} > ul`).append(instancesData.instances);
                            }else{
                                $(`#well_${params.groupId} > ul`).append(singleItemTemplate({node:templateParams}));
                                $(`#well_${params.groupId} > ul`).append(instancesData.instances);
                            }
                            
                        } else {
                            if($(`i[data-target="#well${params.groupId}"]`).length > 0){
                                $(`i[data-target="#well${params.groupId}"]`).trigger('click');
                            }else{
                                $(`i[data-target="#well_${params.groupId}"]`).trigger('click');
                            }
                        }
                        ui.draggable.remove();
                        setTimeout(()=>{ this.makeDraggables(); }, 50);
                    }).catch((error) => {
                        NotificationService.error(error || 'Unknown Error');
                    });
                }
            }
        });
    }

    attachRightClickMenu() {
        const that = this,
            cuttedNode = this.model.get('cuttedNode');

        if (this.contextMenus && typeof this.contextMenus.destroy === 'function') {
            this.contextMenus.destroy();
        }

        this.contextMenus = new BootstrapMenu(constants.CLASS_HAS_MENU, {
            fetchElementData: function($elm) {
                return $elm.find('i').data();
            },
            actions: [{
                name: 'Cut',
                onClick: function(elm) {
                    that.copyActionFromContextMenu(elm);
                },
                isEnabled: function(data) {
                    if (!data) { return; }
                    return (data.nodetype === 'attn');
                }
            }, {
                name: 'Paste',
                onClick: function(elm) {
                    that.pasteActionFromContextMenu(elm);
                },
                isEnabled: function(data) {
                    if (!data) { return; }
                    return that.model.has('cuttedNode') && (data.nodetype === 'group');
                }
            }, {
                name: 'Delete',
                onClick: function(elm) {
                    that.deleteActionFromContextMenu(elm);
                },
                isShown: function(data){
                    if (!data) { return; }
                    // 'helper' function to select nodes in the tree
                    const formId = String(data.itemid).split('_')[1] || data.itemid,
                        groupType = String(data.grouptype),
                        itemId = `${groupType}_${formId}`;
                
                    that.removeItemGroupSelection().addItemGroupSelection( $(`i[data-target="${data.target}"]`) );
                    // Selecting form/report item
                    if (data.nodetype === 'attn') {
                        if ( _.includes([constants.REPORTS_PRIVATE_GROUP_TYPE, constants.REPORTS_SHARED_GROUP_TYPE, 'viewReports'], String(data.grouptype) ) ) {
                            that.renderReportDetails(formId, groupType, itemId);
                        } else if ( _.includes([constants.FORMS_PRIVATE_GROUP_TYPE, constants.FORMS_SHARED_GROUP_TYPE], String(data.grouptype)) ) {
                            that.reloadFormDetails(formId, groupType, itemId);
                        }
                        
                    }
                    // Selecting connections item
                    if ( _.includes(['databases', 'directory', 'web', 'forms', 'google', 'text'], String(data.grouptype)) ) {                        
                        if (String(data.nodetype).length === 1) { // need to render a parent group
                            that.renderConnectionDetails(formId, String(data.nodetype));
                        } else {
                            const ids = data.itemid.split('_');
                            that.renderActionDetails(ids[0], ids[1]);
                        }
                    }

                    return true;
                },
                isEnabled: function(data) {
                    if (!data) { return; }
                    let isDeletable = true;

                    if ( _.includes(that.restrictedItems, data.nodetype) ) { 
                        // disable delete
                        isDeletable = false;
                    } else if ( data.nodetype === 'group' && data.grouptype === 0) {
                        // disable delete on folders for forms->Library sections
                        isDeletable = false;
                    } else if ( data.grouptype === 'viewReports') {
                        // disable delete on reports->view reports
                        isDeletable = false;
                    }

                    return isDeletable;
                }
            }]
        });
    }

    lookForInstances( $item ) {
        let instancesNodeId,
            nodeOfInstances;

        instancesNodeId = $item.find('i').data('target');
        if (instancesNodeId) {
            $(instancesNodeId).attr('aria-expanded', 'false');
            nodeOfInstances = $(instancesNodeId).detach();
        }

        return {instances:nodeOfInstances, domNodeId:instancesNodeId};
    }

    addItemsToSection(group, target) {
        $(target ).html(sectionItemsTemplate(group));
        $(target).collapse('show');
    }

    replaceGroupItemsInModel(mainSectionName, sectionName,  groupId, groupItems) {
        // i.e. FormSections, ReportSections, etc
        var modGroup = {};
        var mainSection = this.model.get(mainSectionName);

        var sectionLength = mainSection.sections.length;

        for (var i = 0; i < sectionLength; i++) {
            if (mainSection.sections[i].sectionName === sectionName) {
                var groupLength = mainSection.sections[i].groups.length;
                for (var g = 0; g < groupLength; g++) {
                    if (mainSection.sections[i].groups[g].id === groupId) {
                        mainSection.sections[i].groups[g].nodes = groupItems;
                        modGroup = mainSection.sections[i].groups[g];
                        break;
                    }
                    if (mainSection.sections[i].groups[g].nodes) {
                        modGroup = this.replaceGroupItemInSubGroups(mainSection.sections[i].groups[g].nodes, groupId, groupItems);
                        if (modGroup.id) { break; }
                    }
                }
                if (modGroup.id) { break; }
            }
        }
/*
        _.forEach(mainSection.sections, function(section) {
            if (section.sectionName === sectionName) {
                _.forEach(section.groups, function (g) {
                    // NEED TO SEARCH NESTED GROUPS HERE Folders in Folders
                    if (g.id === groupId) {
                        g.nodes = groupItems;
                        modGroup = g;
                    }

                    if (g.nodes) {
                       modGroup = replaceGroupInSubGroup(g.nodes);
                    }
                })
            }
        })
*/
        //console.log(mainSection);
        return modGroup;

    }

    validateEnter(ev){
        if(event.keyCode === 13) {
            event.preventDefault();
            return false;
        }
    }

    replaceGroupItemInSubGroups(nodes, groupId, groupItems) {
        var nodesLength = nodes.length;
        var modGroup = {};
        for (var n = 0; n < nodesLength; n++) {
            if (nodes[n].id === groupId) {
                nodes[n].nodes = groupItems;
                modGroup = nodes[n];
                break;
            }
            if (nodes[n].nodes) {
                modGroup = this.replaceGroupItemInSubGroups(nodes[n].nodes, groupId, groupItems);
                if (modGroup.id) { break; }
            }
        }

        return modGroup;
    }

    replaceSectionItemsInModel(mainSectionName, sectionName, items) {

        var modSection = {};
        var mainSection = this.model.get(mainSectionName);

        var sectionLength = mainSection.sections.length;
        for (var i = 0; i < sectionLength; i++) {
            if (mainSection.sections[i].sectionName === sectionName) {
                mainSection.sections[i].nodes = items;
                modSection = mainSection.sections[i];
                break;
            }
        }

        return modSection;
    }


    removeItemGroupSelection() { 
        let groups = $("div.bg-success");
        groups && groups.removeClass('bg-success');

        let items = $("li.bg-success");
        items && items.removeClass('bg-success');

        let links  =$("a.bg-success");
        links && links.removeClass('bg-success');
        
        return this;
    }

    addItemGroupSelection(item){
        $(item).parent('li').addClass('bg-success');

        return this;
    }

    createNewReport(e) {
        if (this.model.get('currentActiveSection')==='reportSections') {
            eventBus.trigger('createNewReport',e);
        }
    }

    deleteActionFromContextMenu(elm) {
        let title = '',
            message = '',
            modalHeight = 130,
            modalWidth = 350;
        elm.canDelete = false;
       let type=this.model.get('selectedTab');

        if (elm.nodetype === 'group') {
            if(type === 'forms') {
                restService.getFormsByGroupType(elm.grouptype, elm.itemid).then((data) => {
                    title = constants.MODAL_DELETE_FOLDER_TITLE;
                    if (data.RESULT.RESPONSE.Group) {
                        modalHeight += 20;
                        message = constants.MODAL_FOLDER_NOT_EMPTY_LABEL;
                    } else {
                        message = constants.MODAL_DELETE_FOLDER_LABEL;
                        elm.canDelete = true;
                    }
                    this._launchModal({title, message, modalHeight, modalWidth, elm});
                });
            }
            else if (type === 'reports'){
                restService.getReportsByGroupType(elm.grouptype, elm.itemid).then((data) => {
                    title = constants.MODAL_DELETE_FOLDER_TITLE;
                    if (data.RESULT.RESPONSE.Group) {
                        modalHeight += 20;
                        message = constants.MODAL_FOLDER_NOT_EMPTY_LABEL;
                    } else {
                        message = constants.MODAL_DELETE_FOLDER_LABEL;
                        elm.canDelete = true;
                    }
                    this._launchModal({title, message, modalHeight, modalWidth, elm});
                });
            }
        } else if(elm.nodetype === 'attn') {            
            if ( _.includes([constants.REPORTS_PRIVATE_GROUP_TYPE, constants.REPORTS_SHARED_GROUP_TYPE], String(elm.grouptype) ) ) {
                this.processDeleteReport(elm);
            } else {
                this.processDeleteform(elm);
            }
        } else if(elm.nodetype === 'editFormInstance') {
            const $elm = $(`a[data-target="${elm.target}"]`),
                other = $elm.data('other') || '';
            this.renderEditFormsViewableInstanceDetailView(String(elm.itemid), other, ()=>{
                setTimeout(()=>{
                    $('div#footer-details').find('#deleteForm').trigger('click');
                },200);
            });
        } else if ( _.includes(['user','userGroupDetail','userPositionDetail','listItem','emailItem'], elm.nodetype) ) {
            this._settingsDeleteModal(elm);
        } else if ( _.includes(['databases', 'directory', 'web', 'forms', 'google', 'text'], elm.grouptype) ) {
            this._deleteConnectionFromContextMenu(elm);
        }
    }

    copyActionFromContextMenu(elm) {
        this.model.set('cuttedNode', elm.itemid, constants.MODEL_SILENT);
    }

    pasteActionFromContextMenu(elm) {
        if ( this.model.get('cuttedNode') ) {
            let that = this;

            const itemData = this.model.get('cuttedNode').split('_');
            const params = {
                formid: itemData[1] || itemData[0],
                isPrivate: (elm.grouptype === Number(constants.FORMS_PRIVATE_GROUP_TYPE)),
                groupId: elm.itemid,
                name: constants.DEFAULT_GROUP_ID,
                groupType: elm.grouptype
            };

            if (this.model.get('currentActiveSection') === 'reportSections') {
                params.reportid = params.formid;
                params.itemid = this.model.get('cuttedNode');
                params.isPrivate = params.groupType === Number(constants.REPORTS_PRIVATE_GROUP_TYPE);
                delete params.formid;
                
                restService.shareReport(params).then( data => {
                    that.pasteActionCallback(elm);
                }).catch((error) => {
                    NotificationService.error(error || 'Unknown Error');
                });
            } else {
                restService.shareForm(params).then( data => {
                    that.pasteActionCallback(elm);
                }).catch((error) => {
                    NotificationService.error(error || 'Unknown Error');
                });
            }
        }
    }

    pasteActionCallback(elm) {
        const itemid = this.model.get('cuttedNode'),
            $sourceNode = $('i[data-itemid="'+itemid+'"]').closest('li[role="button"]'),
            $destinyNode = $(elm.target);
        let cuttedNode = '';

        cuttedNode = $sourceNode.detach();
        // PF-4382: When node is expanded
        if ($destinyNode.hasClass('in')) {
            $destinyNode.find('ul').append(cuttedNode);
        }
        this.model.unset('cuttedNode', constants.MODEL_SILENT);

        setTimeout(()=>{ this.makeDraggables(); }, 50);
    }

    _launchModal({title, message, modalHeight, modalWidth, elm}) {
        let simpleModal = new SimpleConfirmModalView({
            model:new Model({
                subtitle: title,
                confirmationText: message,
                height: modalHeight,
                width: modalWidth
            })
        });

        simpleModal.render().then((result)=>{
            if (result === 'Ok') {
                if (elm.canDelete) { // if folder is "deletable"
                    if (elm.nodetype === 'group') {
                        let $elm = $(`i[data-target="#well${elm.itemid}"]`),
                            $parent = $elm.closest('li[role="button"]'),
                            $childContainer = $(`#well${elm.itemid}`),
                            folderName = $elm.siblings('a').text().trim();
                        switch(this.model.get('selectedTab')) {
                            case 'forms':
                                formFolderService.deleteFormFolder(folderName, elm.itemid, elm.grouptype, elm.parentid).then((result) => {
                                    NotificationService.success(result.msg);
                                    $parent.remove();
                                    $childContainer.remove();
                                }).catch((err) => {
                                    NotificationService.error('Error when deleting folder; ' + err.MESSAGE);
                                });
                                break;
                            case 'reports':
                                reportFolderService.deleteReportFolder(folderName, elm.itemid, elm.grouptype, elm.parentid).then((result) => {
                                    NotificationService.success(result.msg);
                                    $parent.remove();
                                    $childContainer.remove();
                                }).catch((err) => {
                                    NotificationService.error('Error when deleting folder; ' + err.MESSAGE);
                                });
                                break;
                        }
                    }
                }
            }
        }).catch((err)=> {
            NotificationService.error('Error Showing delete modal; ' + err.MESSAGE);
        });
    }

    _optionsForDraggable( item ) {
        return {
            revert: true,
            containment: $(item).closest('div.document'),
            stop: (event, ui) => {
                $(ui.helper).removeClass('drop-disabled');
            }
        }
    }

    loadTrialStatus(reloadSettings){
        if(util.isTrue(listService.accountSettings.IsTrial)){

            const setTrialSettings = () => {

                const trialSettings = listService.accountSettings.license;

                let creationDate = new Date(trialSettings.CreationDate);
                let today = new Date();    
                let difference = Math.round((today - creationDate) / (1000 * 3600 * 24));
                let max = parseInt(trialSettings.RemainingDays);

                trialSettings.trialDays = max;
                trialSettings.daysPassed = difference;
                trialSettings.RemainingDays = max - difference ;

                $("#trial-status").html(trialStatus(trialSettings));
            }

            if(reloadSettings){
                restService.getAccountLicenseStatus().then( data => {
                    setTrialSettings();
                }).catch((error) => {
                    console.log(error || 'Unknown Error');
                });
            }
            else{
                setTrialSettings();
            }

            
        }
    }

    requestQuote(){

        const requestSent = sessionStorage.getItem('quoteRequestSent');
       
        if (!requestSent || !util.isTrue(requestSent)) {
            restService.sendQuoteRequest().then((result) => {
                NotificationService.success(constants.QUOTE_REQUEST);
                sessionStorage.setItem('quoteRequestSent', "true"); //Store in session storage to minimize spamming the sales email
            });
        }
        else{
            NotificationService.success(constants.QUOTE_REQUEST);
        }
    }

    render() {
        var mainSection = this.model.get('currentActiveSection') === 'ViewForms' ? 'formSections':this.model.get('currentActiveSection');

        var mainSections = this.model.get(mainSection);
        const that = this;

        mainSections.optionName = 'Action';
        if (mainSection==='formSections') {
            mainSections.optionName = 'App';
        } else if (mainSection==='reportSections') {
            mainSections.optionName = 'Report';
        }else if(mainSection === 'connectionSections'){
             mainSections.optionName = 'connections';
        }else if(mainSection === 'settingsSections'){
             mainSections.optionName = 'settings';
        }else if(mainSection === 'notificationSections'){
             mainSections.optionName = 'notification';
        }

        this.$el.html(this.template(mainSections)); 

        this.delegateEvents();
        $('.dashboard-left-rail-scroll').on('scroll', (ev)=>{
            that.contextMenus && typeof that.contextMenus.close === 'function' && that.contextMenus.close();
        });

        $('body').off('contextmenu').on('contextmenu', (evt)=>{
            // if bootstrap's context menu is already shown, avoid the browser's context menu
            if ( $('div.bootstrapMenu:visible').length ) {
                evt.preventDefault();
                return false;
            }
        });
        
        $('div.dashboard-left-rail-scroll').off('contextmenu').on('contextmenu', (evt)=>{
            evt.preventDefault();
        });
        return this;
    }
}

export default BaseDashboardLeftPanelView;

